<style lang="less" type="text/less" scoped>
    @import "../styles/common";
    .header{

    }
    .quick-entry{
        overflow:hidden;
        padding:15px 0 0 30px;
        .entry{
            background:rgba(0,227,128,1);
            border-radius:5px;
            box-shadow:0px 2px 10px 2px rgba(90,234,158,0.45);
            width:150px;
            height:100px;
            float:left;
            margin:0 15px 15px 0;
            position:relative;
            &.c2{
                background:rgba(29,125,239,1);
                border-radius:5px;
                box-shadow:0px 2px 10px 2px rgba(103,166,244,0.45);
                .icon{
                    background-image: url(../images/index/ic-update@2x.png);
                }
            }
            &.c3{
                background:rgba(29,125,239,1);
                border-radius:5px;
                box-shadow:0px 2px 10px 2px rgba(103,166,244,0.45);
                .icon{
                    background-image: url(../images/index/ic-pg@2x.png);
                }
            }
            &.c4{
                background:rgba(245,185,42,1);
                border-radius:5px;
                box-shadow:0px 2px 10px 2px rgba(245,197,82,0.45);
                .icon{
                    background-image: url(../images/index/ic-history@2x.png);
                }
            }
            .title{
                position:absolute;
                top:60px;
                text-align:center;
                color:#fff;
                left:0;
                right:0;
                font-size:16px;
            }
            .icon{
                width:30px;
                height:30px;
                margin:20px auto 0 auto;
                background:url(../images/index/ic-bl@2x.png) no-repeat center center;
                background-size:contain;

            }
        }
    }
    .article-title{
        position:relative;
        padding-left:20px;
        font-weight:bold;
        font-size:18px;
        color:#111;
        line-height:30px;
        margin-bottom:15px;
        .right{
            position:absolute;
            right:20px;
            top:0;
            font-size:14px;
            font-weight:normal;
            color:#ccc;
        }
    }
</style>
<template>
    <div class="wrapper" ref="wrapper">
        <div class="header">
            <div class="container">
                <Slider :list="list"></Slider>
            </div>
        </div>
        <div class="content" ref="content">
            <div class="quick-entry">
                <div class="entry c1" @click="$router.go({name:'survey-result-list'})">
                    <div class="icon"></div>
                    <div class="title">我的病历</div>
                </div>
                <div class="entry c2">
                    <div class="icon"></div>
                    <div class="title">上传化验单</div>
                </div>
                <div class="entry c3" @click="$router.go({name:'survey-list'})">
                    <div class="icon"></div>
                    <div class="title">疾病风险评估</div>
                </div>
                <div class="entry c4" @click="$router.go({name:'survey-result-list'})">
                    <div class="icon"></div>
                    <div class="title">病历历史</div>
                </div>
            </div>
            <div class="article-title">
                文章精选
                <span class="right" @click="$router.go({name:'news'})">更多</span>
            </div>
            <div class="article-list">
                <ArticleListItem v-for="item in list" :item="item"/>
            </div>
        </div>
        <BottomBar :index="0"></BottomBar>
    </div>
</template>
<script type="text/ecmascript-6">

    import api from '../lib/api';
    import BottomBar from '../components/BottomBar';
    import PullReload from '../components/PullReload';
    import user from '../lib/UserService';
    import Slider from '../components/Slider.vue';
    import ArticleListItem from '../components/ArticleListItem.vue';

    export default {
        data() {
            return {
                list:[]
            }
        },
        computed: {},
        methods: {
            async init(){
                let res = await api.getArticleList({tag:'',page:0,size:5});
                this.list = res.list;
            },

        },
        components: {
            BottomBar,
            Slider,
            PullReload,
            ArticleListItem
        },
        mounted() {
            window.vm = this;

            this.init();
        }
    }
</script>


// WEBPACK FOOTER //
// index.vue?fe2a00a2